export default __webpack_public_path__ + "static/media/vip-bg.e0500395.webp";